<template>
	<li class='deals__item' :data-item-id='deal.id'>
		<div class='deal'>
			<header class='deal__picture' :style='{backgroundImage: `url(${(deal.image_big)?(deal.image_big):("/assets/img/placeholder.png")})`}'>
				<div class='deal__badge deal__badge--public' v-if='deal.is_public'>
					Public
				</div>
				<a class='btn btn--white waves-effect dela__edit' :href='`/deals/${deal.id}/edit`' v-if='canEditBtn'>
					<svg class='icon'>
						<use xlink:href='#icon-edit'/>
					</svg>
				</a>
				<a class='btn btn--white waves-effect' :href='`/deals/new?copy_from=${deal.id}`' v-if='showCloneBtn'>
					<svg class='icon'>
						<use xlink:href='#icon-clone' />
					</svg>
				</a>
				<button type='submit'
					class='btn btn--white waves-effect deal__make'
					v-if='showMakePrivateBtn'
					@click='$emit("make-private", deal.id)'
				>
					Make private
				</button>
				<button class='btn btn--white waves-effect deal__deleted' @click='$emit("remove", {id: deal.id, url: `/deals/${deal.id}/delete`})'  v-if='canDeleteBtn'>
					<svg class='icon'>
						<use xlink:href='#icon-remove'/>
					</svg>
				</button>
			</header>

			<div class='deal__content'>
				<p class='deal__author' v-if='showCreator'>
					Posted by <b>{{ deal.creator }}</b>
				</p>
				<p class='deal__main'>
					<span class='deal__price' v-if='deal.home_price'>
						$ {{deal.home_price | formatPrice}}
					</span>
					<span class='deal__badge'>
						{{ deal.coc | formatCOC }}% C.O.C.
					</span>
				</p>
				<p class='deal__name'>
					<span v-if='deal.address'>{{deal.address}}</span>
					<small v-else><i>No address</i></small>
				</p>
				<ul class='deal__values' v-if='showDealValues'>
					<li class='deal__value' v-if='deal.asking_price'>
						Asking price:
						$ {{ deal.asking_price | formatPrice }}
					</li>
					<li class='deal__value' v-if='deal.appraised_value'>
						Appraised value:
						$ {{ deal.appraised_value | formatPrice }}
					</li>
				</ul>
				<dealCounts :deal='deal' />
			</div>
		</div>
	</li>
</template>

<script>
import deal from '../mixins/deal';
export default {
	name:   'DealCard',
	mixins: [deal]
};
</script>
